import { render, staticRenderFns } from "./SouhuoList.vue?vue&type=template&id=8a979ebe&scoped=true&"
import script from "./SouhuoList.vue?vue&type=script&lang=js&"
export * from "./SouhuoList.vue?vue&type=script&lang=js&"
import style0 from "./SouhuoList.vue?vue&type=style&index=0&id=8a979ebe&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a979ebe",
  null
  
)

export default component.exports